/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PortfolioCategory } from './';
import {
    PortfolioCategoryFromJSON,
    PortfolioCategoryFromJSONTyped,
    PortfolioCategoryToJSON,
} from './';
import type { PortfolioPeriod } from './';
import {
    PortfolioPeriodFromJSON,
    PortfolioPeriodFromJSONTyped,
    PortfolioPeriodToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioItemCreateRequest
 */
export interface PortfolioItemCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemCreateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemCreateRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemCreateRequest
     */
    thumbnail: string;
    /**
     * Content blocks stored as opaque JSON (e.g. TipTap document)
     * @type {object}
     * @memberof PortfolioItemCreateRequest
     */
    contentBlocks: object;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioItemCreateRequest
     */
    published: boolean;
    /**
     * 
     * @type {PortfolioPeriod}
     * @memberof PortfolioItemCreateRequest
     */
    period?: PortfolioPeriod;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioItemCreateRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioItemCreateRequest
     */
    industryExpertises?: Array<string>;
    /**
     * 
     * @type {PortfolioCategory}
     * @memberof PortfolioItemCreateRequest
     */
    category?: PortfolioCategory;
    /**
     * ID of the linked profile experience, if any
     * @type {string}
     * @memberof PortfolioItemCreateRequest
     */
    experienceId?: string;
}

/**
 * Check if a given object implements the PortfolioItemCreateRequest interface.
 */
export function instanceOfPortfolioItemCreateRequest(value: object): value is PortfolioItemCreateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('thumbnail' in value) || value['thumbnail'] === undefined) return false;
    if (!('contentBlocks' in value) || value['contentBlocks'] === undefined) return false;
    if (!('published' in value) || value['published'] === undefined) return false;
    return true;
}

export function PortfolioItemCreateRequestFromJSON(json: any): PortfolioItemCreateRequest {
    return PortfolioItemCreateRequestFromJSONTyped(json, false);
}

export function PortfolioItemCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioItemCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
        'thumbnail': json['thumbnail'],
        'contentBlocks': json['contentBlocks'],
        'published': json['published'],
        'period': json['period'] == null ? undefined : PortfolioPeriodFromJSON(json['period']),
        'tags': json['tags'] == null ? undefined : json['tags'],
        'industryExpertises': json['industryExpertises'] == null ? undefined : json['industryExpertises'],
        'category': json['category'] == null ? undefined : PortfolioCategoryFromJSON(json['category']),
        'experienceId': json['experienceId'] == null ? undefined : json['experienceId'],
    };
}

export function PortfolioItemCreateRequestToJSON(value?: PortfolioItemCreateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'description': value['description'],
        'thumbnail': value['thumbnail'],
        'contentBlocks': value['contentBlocks'],
        'published': value['published'],
        'period': PortfolioPeriodToJSON(value['period']),
        'tags': value['tags'],
        'industryExpertises': value['industryExpertises'],
        'category': PortfolioCategoryToJSON(value['category']),
        'experienceId': value['experienceId'],
    };
}

